/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Stat_1_DescInputs */

const tr_landing_intro_stat_1_desc = /** @type {(inputs: Landing_Intro_Stat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11: hepsi tek panelde.`)
};

const en_landing_intro_stat_1_desc = /** @type {(inputs: Landing_Intro_Stat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11: all in one panel.`)
};

const de_landing_intro_stat_1_desc = /** @type {(inputs: Landing_Intro_Stat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11: alles in einem Panel.`)
};

const ru_landing_intro_stat_1_desc = /** @type {(inputs: Landing_Intro_Stat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11: всё в одной панели.`)
};

/**
* | output |
* | --- |
* | "Trendyol, Shopify, Hepsiburada, n11: all in one panel." |
*
* @param {Landing_Intro_Stat_1_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_stat_1_desc = /** @type {((inputs?: Landing_Intro_Stat_1_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Stat_1_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_stat_1_desc(inputs)
	if (locale === "de") return de_landing_intro_stat_1_desc(inputs)
	if (locale === "ru") return ru_landing_intro_stat_1_desc(inputs)
	return tr_landing_intro_stat_1_desc(inputs)
});